import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=4746b0bb&scoped=true&"
import script from "./ProductDetailView.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailView.vue?vue&type=style&index=0&id=4746b0bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746b0bb",
  null
  
)

export default component.exports